const container = "_b7ncyrymzl";
const header = "_b7nh9fxawi";
const headerText = "_b7nhc3c7bt";
const heading = "_b7nhh0ltq0";
const elementToolbar = "_b7nez78y1n";

export { container, elementToolbar, header, headerText, heading };
import "./_slider.style.linaria.module.css";
//# sourceMappingURL=_slider.style.js.map
